import React, { FC, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { ModalContext } from '../../../../../contexts/ModalContext'
import { BadgeHook } from '../../../hooks/useBadges'
import useBadgeSwiperData from '../../../hooks/useBadgeSwiperData'
import { TierData } from '../../../types/tierData'
import BadgesCategoryList from './components/BadgesCategoryList'

interface BadgesCardProps {
	badgeHook: BadgeHook
}

const BadgesCard: FC<BadgesCardProps> = ({ badgeHook }) => {
	const { insertModal } = useContext(ModalContext)
	const { t } = useTranslation('pages_saving', { keyPrefix: 'badgesCard' })

	const swiperData = useBadgeSwiperData({ badgeHook })

	const handleSeeAll = (tiers: TierData[], categoryName: string) => {
		insertModal('badges-tiers', { tiers, categoryName })
	}

	return (
		<div className='display flex flex-col gap-4 py-4 bg-white dark:bg-[#0d2d30] border border-[#c4c4c4] dark:border-[#144448] rounded-xl max-w-full'>
			<span className='text-center font-semibold text-lg tracking-wide text-text-dark dark:text-white'>
				{t('title')}
			</span>

			<BadgesCategoryList
				swiperData={swiperData}
				badgeHook={badgeHook}
				onSeeAll={handleSeeAll}
				t={t}
			/>
		</div>
	)
}

export default BadgesCard
